import { render } from "./freeText.vue?vue&type=template&id=6e63bfd9&scoped=true"
import script from "./freeText.vue?vue&type=script&lang=js"
export * from "./freeText.vue?vue&type=script&lang=js"

import "./freeText.vue?vue&type=style&index=0&id=6e63bfd9&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e63bfd9"]])

export default __exports__